import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { TDashboardKRA } from "../models/dashboard";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const getDashboardKRA = async (params: any): Promise<TDashboardKRA> => {
  try {
    const response = await axios.post(getUrl(ApiType.DASHBOARD_KRA), params);
    return response?.data;
  } catch (error) {
    return throwApiError(error, ErrorMessages.dashboardSummaryAPIError, { badRequestOrder: "errorsFirst" });
  }
};
